/*

Files in the rsc directory are meant to be packaged as part of the RSC graph using next-app-loader.

*/

// When postpone is available in canary React we can switch to importing it directly
export { Postpone } from '../dynamic-rendering'
